// AUTO-GENERIERT aus erstanmeldung-briefing.json — nicht von Hand editieren.
export const ONBOARDING = {
  "id": "onboarding.v1",
  "version": 1,
  "seenFlag": "onboarding.v1.seen",
  "reopenVia": [
    "cmdk:Kurzbriefing",
    "help:kurzbriefing"
  ],
  "tenantPrependSlug": "willkommen",
  "intro": {
    "title": "Willkommen!",
    "body": "Schön, dass du da bist. In einer Minute zeigen wir dir das Wichtigste. Alles findest du später über die Suche (⌘K) → „Hilfe“."
  },
  "cards": [
    {
      "key": "status",
      "title": "Setze deinen Status",
      "body": "Oben im Kopf stellst du ein, ob du „Verfügbar“ bist. Nur dann werden dir Videoanrufe zugestellt.",
      "ctaHelpSlug": "status-setzen",
      "action": "openStatus"
    },
    {
      "key": "devices",
      "title": "Prüfe Kamera & Mikrofon",
      "body": "Erlaube dem Browser den Zugriff und mach den kurzen Geräte-Check — so bist du sicher erreichbar.",
      "ctaHelpSlug": "geraete-pruefen",
      "action": "openSettings:devices",
      "softRequired": true
    },
    {
      "key": "answer",
      "title": "So nimmst du Anrufe an",
      "body": "Enter nimmt an, Esc lehnt ab. Den Ruf kannst du auch „abdocken“ (schwebendes Fenster).",
      "ctaHelpSlug": "anruf-annehmen"
    },
    {
      "key": "controlbar",
      "title": "Die Steuerleiste im Gespräch",
      "body": "Mikrofon, Kamera (inkl. Dokumentenkamera), Lautsprecher, Hintergrund, Bildschirm teilen, Übersetzung, Aufzeichnung, Einladen, Signieren, Weiterleiten, Auflegen. Pfeile = Geräteauswahl.",
      "ctaHelpSlug": "kamera-umschalten"
    },
    {
      "key": "documents",
      "title": "Scannen, zoomen, signieren",
      "body": "Ins hochauflösende Stele-Bild zoomen, Scan auslösen, PDF zur Unterschrift an die Stele senden. Dokumente liegen in der Session-Ablage.",
      "ctaHelpSlug": "scannen"
    },
    {
      "key": "security",
      "title": "Sicher & verschlüsselt",
      "body": "Audio, Video und Inhalte laufen Ende-zu-Ende-verschlüsselt; der Server sieht keine Inhalte. Aufzeichnung nur mit Einwilligung.",
      "ctaHelpSlug": "datenschutz-e2ee"
    },
    {
      "key": "help",
      "title": "Hilfe ist immer dabei",
      "body": "⌘K und „Hilfe“ tippen — zu jedem Element gibt es eine kurze Erklärung. Viele Elemente bieten ein „?“.",
      "ctaHelpSlug": "suche-befehle"
    }
  ],
  "finish": {
    "title": "Du bist startklar.",
    "body": "Setze deinen Status auf „Verfügbar“ — der erste Anruf kann kommen.",
    "buttons": [
      {
        "label": "Status auf „Verfügbar“ setzen",
        "action": "setStatus:available"
      },
      {
        "label": "Zu den Einstellungen",
        "action": "openSettings"
      },
      {
        "label": "Schließen",
        "action": "dismiss"
      }
    ]
  }
} as const;
